import { THERMAL_ZONE_STATUS } from '../../config/status';

import './ThermalZoneStatusBlock.scss';

interface ThermalZoneStatusBlockProps {
  status: (typeof THERMAL_ZONE_STATUS)[keyof typeof THERMAL_ZONE_STATUS];
}

export const ThermalZoneStatusBlock = ({ status }: ThermalZoneStatusBlockProps) => {
  return (
    <div className={`thermal-zone-status-block ${status?.cssClass || 'unmanaged'} `}>
      <div
        className={`status-color-indicator ${status && status?.cssClass ? status.cssClass : ''}`}
      />
      <div className="thermal-zone-status-block--label">{status.label}</div>
    </div>
  );
};
